/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicBookingInvoicePdfPathParameters } from 'api/actions/get-public-booking-invoice-pdf/get-public-booking-invoice-pdf-path-parameters';
import { GetPublicBookingInvoicePdfResponse } from 'api/actions/get-public-booking-invoice-pdf/get-public-booking-invoice-pdf-response';

type GetPublicBookingInvoicePdfQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicBookingInvoicePdf action.
 */
export const getPublicBookingInvoicePdfActionPath = new SweetPath<keyof GetPublicBookingInvoicePdfPathParameters>(
  '/reservations/public/bookings/{token}/invoice/pdf',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetPublicBookingInvoicePdf actions.
 */
export default function createGetPublicBookingInvoicePdfAction(axios: AxiosInstance) {
  return function getPublicBookingInvoicePdfAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicBookingInvoicePdfPathParameters;
    query?: GetPublicBookingInvoicePdfQueryParameters;
  }) {
    const path = getPublicBookingInvoicePdfActionPath.insert(parameters);

    return axios.get<GetPublicBookingInvoicePdfResponse, GetPublicBookingInvoicePdfResponse>(path, {
      params: query,
      headers,
      responseType: 'blob',
    });
  };
}
